import { observer } from "mobx-react";
import * as React from "react";
import { Button } from "./Button";

@observer
export class ChangeLanguageButton extends Button {

	render() {
		return <Button {...this.props} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M12,12V32H32V12ZM25,29,23.9,25.41h-4l-1,3.59H15.61l4.28-14h4.16l4.34,14Z" />
					<path d="M21.86,17.37h0c-.2.83-.41,1.89-.64,2.7l-.83,3h3.09l-.87-3C22.32,19.24,22.07,18.2,21.86,17.37Z" />
					<path d="M0,0V20H10V13.72A20.18,20.18,0,0,1,5.74,17L4.65,15a19,19,0,0,0,4-3.18,14,14,0,0,1-2.47-5l2.26-.44a11.77,11.77,0,0,0,1.72,3.59,9.64,9.64,0,0,0,1.54-3.87H4.14V3.76H8.62V2.61h2.74V3.76h4.47v2.3H14A11.21,11.21,0,0,1,12.77,10H20V0Z" />
				</svg>
			</i>
		</Button>;
	}
}
